/**
 * @author mll
 * @date 2021-03-31
 * @desc 话题关注列表
 */
import React from 'react'
import { WizTableForm } from '../../../common'
import { component_tool } from '../../../../tool'

let { WizDataTable, WizButton, WizModal } = component_tool

let componentName = 'topicFollow'

const columns = (e) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '账号',
      name: 'userName',
      tableItem: {
        width: 150
      },
      searchItem: {},
    },
    {
      title: '姓名',
      name: 'fullName',
      tableItem: {
        width: 150
      },
      searchItem: {},
    },
    {
      title: '用户昵称',
      name: 'nickName',
      tableItem: {
        width: 150
      }
    },
    {
      title: '身份证号/工号',
      name: 'idCard',
      tableItem: {
        width: 150,
      },
    },
    {
      title: '手机号',
      name: 'mobile',
      tableItem: {
        width: 200
      },
    },
    {
      title: '用户属性',
      name: 'userType',
      tableItem: { width: 100 },
      dict: [
        { code: 0, codeName: '学员' },
        { code: 1, codeName: 'SGM总部' },
        { code: 2, codeName: 'SGM区域' },
        { code: 3, codeName: '供应商' },
        { code: 4, codeName: '系统用户' }
      ]
    },
    {
      title: '人员状态',
      name: 'state',
      tableItem: { width: 100 },
      dict: [
        { code: 0, codeName: '禁用' },
        { code: 1, codeName: '启用' },
      ]
    },
    {
      title: '关注时间',
      name: 'topicFollowTime',
      tableItem: { width: 200 }
    }
  ]
}

const templateConfig = (e) => {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns: columns(e),
        btnAccessCheck: false,
        searchBarProps: {
          collapse: false,
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          selectType: 'checkbox',
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: [],
        rowOperateView: []
      }
    }
  }
}

const apis = (defaultParams = {}) => {
  let { topicId } = defaultParams
  return {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: { topicId: topicId }
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: { topicId: topicId }
      }
    }
  }
}

let reduxTemplateConfig = (args) => {
  let { defaultParams, ...rest } = args
  return {
    apis: apis(defaultParams),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...rest
  }
}

export { reduxTemplateConfig, templateConfig }
